// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2ERt0","label":"Completed_label__123hE"};